export class BrushUI {
    constructor(brushSystem, texturePainter) {
        this.brushSystem = brushSystem;
        this.texturePainter = texturePainter;
        
        this.initializeUI();
        
        setTimeout(() => {
            this.bindEvents();
        }, 100);
    }
    
    initializeUI() {
        this.createBrushControls();
        this.createBrushPresets();
        this.updateUIVisibility();
    }
    
    createBrushControls() {
        const sidebar = document.getElementById('sidebar');
        if (sidebar) {
            const brushPanel = document.createElement('div');
            brushPanel.className = 'panel';
            brushPanel.id = 'brushPanel';
            brushPanel.style.display = 'none';
            
            brushPanel.innerHTML = `
                <div class="panel-header">🖌️ Brush Controls</div>
                <div class="panel-content">
                    <div class="control-group mode-toggle-group">
                        <button id="brushModeToggle" class="mode-button active" data-mode="paint">
                            🎨 Paint Mode
                        </button>
                        <button id="eraseModeToggle" class="mode-button" data-mode="erase">
                            🧽 Erase Mode
                        </button>
                    </div>
                    <div class="shortcut-hint">Shortcut: X key to toggle</div>
                    
                    <div class="control-group">
                        <label>Brush Size: <span class="value-display" id="brushSizeValue">10px</span></label>
                        <input type="range" id="brushSizeSlider" min="1" max="200" value="10" />
                        <div class="shortcut-hint">Shortcut: [ ] keys</div>
                    </div>
                    
                    <div class="control-group">
                        <label>Opacity: <span class="value-display" id="brushOpacityValue">100%</span></label>
                        <input type="range" id="brushOpacitySlider" min="0" max="100" value="100" />
                    </div>
                    
                    <div class="control-group">
                        <label>Hardness: <span class="value-display" id="brushHardnessValue">80%</span></label>
                        <input type="range" id="brushHardnessSlider" min="0" max="100" value="80" />
                    </div>
                    
                    <div class="control-group" id="paintControls">
                        <label>Brush Color:</label>
                        <input type="color" id="brushColorPicker" value="#000000" />
                        <div class="color-presets">
                            <button class="color-preset" style="background: #000000" data-color="#000000" title="Black"></button>
                            <button class="color-preset" style="background: #ffffff" data-color="#ffffff" title="White"></button>
                            <button class="color-preset" style="background: #ff0000" data-color="#ff0000" title="Red"></button>
                            <button class="color-preset" style="background: #00ff00" data-color="#00ff00" title="Green"></button>
                            <button class="color-preset" style="background: #0000ff" data-color="#0000ff" title="Blue"></button>
                            <button class="color-preset" style="background: #ffff00" data-color="#ffff00" title="Yellow"></button>
                            <button class="color-preset" style="background: #ff00ff" data-color="#ff00ff" title="Magenta"></button>
                            <button class="color-preset" style="background: #00ffff" data-color="#00ffff" title="Cyan"></button>
                        </div>
                    </div>
                    
                    <div class="control-group">
                        <label>
                            <input type="checkbox" id="strokeInterpolation" checked>
                            Smooth Strokes
                        </label>
                    </div>
                    
                    <div class="control-group">
                        <label>
                            <input type="checkbox" id="brushCursorToggle" checked>
                            Show Brush Cursor
                        </label>
                    </div>
                    
                    <div class="control-group">
                        <button id="undoStroke" title="Undo last stroke">↶ Undo Stroke</button>
                        <button id="clearBrushStrokes" title="Clear all brush strokes">🗑️ Clear All</button>
                    </div>
                </div>
            `;
            
            const firstPanel = sidebar.querySelector('.panel');
            if (firstPanel) {
                sidebar.insertBefore(brushPanel, firstPanel);
            } else {
                sidebar.appendChild(brushPanel);
            }
        }
    }
    
    createBrushPresets() {
        const brushPanel = document.getElementById('brushPanel');
        if (brushPanel) {
            const presetsHTML = `
                <div class="panel-section">
                    <div class="section-header">Brush Presets</div>
                    <div class="brush-presets">
                        <button class="brush-preset" data-preset="detail" title="Detail Brush">
                            🖊️ Detail
                        </button>
                        <button class="brush-preset" data-preset="soft" title="Soft Brush">
                            🖌️ Soft
                        </button>
                        <button class="brush-preset" data-preset="hard" title="Hard Brush">
                            ✏️ Hard
                        </button>
                        <button class="brush-preset" data-preset="large" title="Large Brush">
                            🖍️ Large
                        </button>
                    </div>
                </div>
            `;
            
            const panelContent = brushPanel.querySelector('.panel-content');
            panelContent.insertAdjacentHTML('beforeend', presetsHTML);
        }
    }
    
    bindEvents() {
        this.bindModeEvents();
        this.bindBrushControlEvents();
        this.bindPresetEvents();
        this.bindKeyboardShortcuts();
    }
    
    bindModeEvents() {
        const brushModeButton = document.getElementById('compactModeBrush');
        if (brushModeButton) {
            brushModeButton.addEventListener('click', () => {
                this.texturePainter.setProjectionMode('brush');
                this.updateModeButtons('brush');
            });
        }
        
        const brushModeToggle = document.getElementById('brushModeToggle');
        const eraseModeToggle = document.getElementById('eraseModeToggle');
        
        if (brushModeToggle) {
            brushModeToggle.addEventListener('click', () => {
                this.setBrushMode('paint');
            });
        }
        
        if (eraseModeToggle) {
            eraseModeToggle.addEventListener('click', () => {
                this.setBrushMode('erase');
            });
        }
    }
    
    bindBrushControlEvents() {
        const brushSizeSlider = document.getElementById('brushSizeSlider');
        if (brushSizeSlider) {
            brushSizeSlider.addEventListener('input', (e) => {
                const size = parseInt(e.target.value);
                document.getElementById('brushSizeValue').textContent = size + 'px';
                this.brushSystem.setBrushSize(size);
            });
        }
        
        const brushOpacitySlider = document.getElementById('brushOpacitySlider');
        if (brushOpacitySlider) {
            brushOpacitySlider.addEventListener('input', (e) => {
                const opacity = e.target.value / 100;
                document.getElementById('brushOpacityValue').textContent = e.target.value + '%';
                this.brushSystem.setBrushOpacity(opacity);
            });
        }
        
        const brushHardnessSlider = document.getElementById('brushHardnessSlider');
        if (brushHardnessSlider) {
            brushHardnessSlider.addEventListener('input', (e) => {
                const hardness = e.target.value / 100;
                document.getElementById('brushHardnessValue').textContent = e.target.value + '%';
                this.brushSystem.setBrushHardness(hardness);
            });
        }
        
        const brushColorPicker = document.getElementById('brushColorPicker');
        if (brushColorPicker) {
            brushColorPicker.addEventListener('change', (e) => {
                this.brushSystem.setBrushColor(e.target.value);
            });
        }
        
        const colorPresets = document.querySelectorAll('.color-preset');
        colorPresets.forEach(preset => {
            preset.addEventListener('click', () => {
                const color = preset.dataset.color;
                document.getElementById('brushColorPicker').value = color;
                this.brushSystem.setBrushColor(color);
            });
        });
        
        const strokeInterpolation = document.getElementById('strokeInterpolation');
        if (strokeInterpolation) {
            strokeInterpolation.addEventListener('change', (e) => {
                this.brushSystem.strokeInterpolation = e.target.checked;
            });
        }
        
        const brushCursorToggle = document.getElementById('brushCursorToggle');
        if (brushCursorToggle) {
            brushCursorToggle.addEventListener('change', (e) => {
                this.brushSystem.enableCursor(e.target.checked);
            });
        }
        
        const undoStroke = document.getElementById('undoStroke');
        if (undoStroke) {
            undoStroke.addEventListener('click', () => {
                this.brushSystem.undoLastStroke();
            });
        }
        
        const clearBrushStrokes = document.getElementById('clearBrushStrokes');
        if (clearBrushStrokes) {
            clearBrushStrokes.addEventListener('click', () => {
                if (confirm('Clear all brush strokes? This cannot be undone.')) {
                    this.clearAllBrushStrokes();
                }
            });
        }
    }
    
    bindPresetEvents() {
        const presetButtons = document.querySelectorAll('.brush-preset');
        presetButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.applyBrushPreset(button.dataset.preset);
            });
        });
    }
    
    bindKeyboardShortcuts() {
        document.addEventListener('keydown', (e) => {
            if (window.hotkeysPaused) return;

            if (!this.brushSystem.isEnabled()) return;
            
            switch(e.key) {
                case '[':
                    e.preventDefault();
                    this.adjustBrushSize(-2);
                    break;
                case ']':
                    e.preventDefault();
                    this.adjustBrushSize(2);
                    break;
                case 'x':
                case 'X':
                    e.preventDefault();
                    this.toggleBrushMode();
                    break;
                case 'b':
                case 'B':
                    if (e.ctrlKey || e.metaKey) {
                        e.preventDefault();
                        this.toggleBrushMode();
                    }
                    break;
            }
        });
    }
    
    updateModeButtons(activeMode) {
        const modeButtons = document.querySelectorAll('.compact-mode-button');
        modeButtons.forEach(btn => {
            btn.classList.toggle('active', btn.dataset.mode === activeMode);
        });
        
        const usageGuides = document.querySelectorAll('.compact-usage-guide');
        usageGuides.forEach(guide => {
            guide.style.display = guide.id === `compactUsage${activeMode.charAt(0).toUpperCase() + activeMode.slice(1)}` ? 'block' : 'none';
        });
        
        this.updateUIVisibility();
    }
    
    updateUIVisibility() {
        const isBrushMode = this.texturePainter.projectionMode === 'brush';
        
        const brushPanel = document.getElementById('brushPanel');
        if (brushPanel) {
            brushPanel.style.display = isBrushMode ? 'block' : 'none';
        }
        
        const projection2DControls = document.getElementById('projection2DControls');
        if (projection2DControls) {
            projection2DControls.style.display = isBrushMode ? 'none' : 'block';
        }
    }
    
    setBrushMode(mode) {
        this.brushSystem.setBrushMode(mode);
        
        const brushModeToggle = document.getElementById('brushModeToggle');
        const eraseModeToggle = document.getElementById('eraseModeToggle');
        
        if (brushModeToggle && eraseModeToggle) {
            brushModeToggle.classList.toggle('active', mode === 'paint');
            eraseModeToggle.classList.toggle('active', mode === 'erase');
        }
        
        const paintControls = document.getElementById('paintControls');
        if (paintControls) {
            paintControls.style.display = mode === 'paint' ? 'block' : 'none';
        }
    }
    
    toggleBrushMode() {
        const currentMode = this.brushSystem.brushMode;
        const newMode = currentMode === 'paint' ? 'erase' : 'paint';
        this.setBrushMode(newMode);
    }
    
    adjustBrushSize(delta) {
        const currentSize = this.brushSystem.brushSize;
        const newSize = Math.max(1, Math.min(200, currentSize + delta));
        
        this.brushSystem.setBrushSize(newSize);
        
        const brushSizeSlider = document.getElementById('brushSizeSlider');
        const brushSizeValue = document.getElementById('brushSizeValue');
        
        if (brushSizeSlider) brushSizeSlider.value = newSize;
        if (brushSizeValue) brushSizeValue.textContent = newSize + 'px';
    }
    
    applyBrushPreset(presetName) {
        const presets = {
            detail: { size: 10, opacity: 0.8, hardness: 0.9 },
            soft: { size: 50, opacity: 0.3, hardness: 0.2 },
            hard: { size: 30, opacity: 1.0, hardness: 1.0 },
            large: { size: 100, opacity: 0.6, hardness: 0.5 },
        };
        
        const preset = presets[presetName];
        if (preset) {
            this.brushSystem.setBrushSize(preset.size);
            this.brushSystem.setBrushOpacity(preset.opacity);
            this.brushSystem.setBrushHardness(preset.hardness);
            
            this.updateBrushUI(preset);
            
            this.texturePainter.updateStatus(`Applied ${presetName} brush preset`);
        }
    }
    
    updateBrushUI(settings) {
        if (settings.size !== undefined) {
            const slider = document.getElementById('brushSizeSlider');
            const value = document.getElementById('brushSizeValue');
            if (slider) slider.value = settings.size;
            if (value) value.textContent = settings.size + 'px';
        }
        
        if (settings.opacity !== undefined) {
            const slider = document.getElementById('brushOpacitySlider');
            const value = document.getElementById('brushOpacityValue');
            const opacityPercent = Math.round(settings.opacity * 100);
            if (slider) slider.value = opacityPercent;
            if (value) value.textContent = opacityPercent + '%';
        }
        
        if (settings.hardness !== undefined) {
            const slider = document.getElementById('brushHardnessSlider');
            const value = document.getElementById('brushHardnessValue');
            const hardnessPercent = Math.round(settings.hardness * 100);
            if (slider) slider.value = hardnessPercent;
            if (value) value.textContent = hardnessPercent + '%';
        }
    }
    
    clearAllBrushStrokes() {
        this.texturePainter.uvChannels.forEach((channel, index) => {
            if (channel && channel.decalContext) {
                channel.decalContext.clearRect(0, 0, channel.decalCanvas.width, channel.decalCanvas.height);
                this.texturePainter.compositeTexture(index);
            }
        });
        
        this.brushSystem.clearStrokes();
        this.texturePainter.updateAllUDIMTextures();
        this.texturePainter.updateStatus('All brush strokes cleared');
    }
    
    dispose() {
        const brushPanel = document.getElementById('brushPanel');
        if (brushPanel) {
            brushPanel.remove();
        }
        
        const brushModeButton = document.getElementById('compactModeBrush');
        if (brushModeButton) {
            brushModeButton.remove();
        }
        
        const brushUsageGuide = document.getElementById('compactUsageBrush');
        if (brushUsageGuide) {
            brushUsageGuide.remove();
        }
    }
}
